/* eslint-disable react/prop-types */

import React from "react";

import { splitStringToParagraphs } from "~utils/helpers";

const List = ({ section, sectionKey, bannerFont }) => {
  const colorClasses = `bg-${section.backgroundColor} border-t-${section.borderTop} text-${section.fontColor}`;

  return (
    <section
      className={`w-full relative block pt-v7 xs:pt-v14 pb-v14 xs:pb-v28 ${colorClasses}`}
    >
      <ul className="case-study-list relative">
        {section.items.map((listItem, listItemIndex) => {
          const key = `${sectionKey}-${listItemIndex}`;

          return (
            <li key={key} className="grid mb-v7 xs:mb-v14">
              <header className="grid-end-6 xs:grid-end-8 pr-v2 sm:pr-0">
                {listItem?.subheading && (
                  <h4 className="whitespace-pre-wrap mb-v2 b2 universal-sans">
                    {listItem.subheading}
                  </h4>
                )}

                <h3 className={`whitespace-pre-wrap f3 ${bannerFont}`}>
                  {splitStringToParagraphs(listItem.heading, ``)}
                </h3>
              </header>

              <p
                className={`grid-end-6 xs:grid-end-8 ${listItem.subheading &&
                  `mt-v4`} xs:mt-v4 whitespace-pre-wrap b1 universal-sans`}
              >
                {listItem.content}
              </p>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default List;
